module.exports = __webpack_public_path__ + "static/media/671.05e39908.webp";